import Icon from '../Icon';

const StarFilled = (props) => (
  <Icon
    viewBox="0 0 26 24"
    {...props}
    path="M15.0174 1.48209C14.1185 -0.0675955 11.8814 -0.0675998 10.9826 1.48209L8.22979 6.2279C7.97604 6.66535 7.53748 6.96387 7.03758 7.0394L2.46643 7.73008C0.473838 8.03115 -0.225104 10.5479 1.3267 11.834L4.65732 14.5945C5.12481 14.9819 5.34462 15.5931 5.23106 16.1896L4.29809 21.0909C3.93264 23.0109 5.94738 24.5026 7.67609 23.592L12.2238 21.1966C12.7096 20.9407 13.2903 20.9407 13.7762 21.1966L18.3239 23.592C20.0526 24.5026 22.0673 23.0109 21.7019 21.0909L20.7689 16.1896C20.6554 15.5931 20.8752 14.9819 21.3426 14.5945L24.6733 11.834C26.2251 10.5479 25.5261 8.03115 23.5335 7.73008L18.9624 7.0394C18.4625 6.96387 18.0239 6.66535 17.7702 6.22791L15.0174 1.48209Z"
  />
);

export default StarFilled;
